class WishList {
  constructor(id, items) {
    this.id = id;
    this.items = items;
  }
}

export default WishList;
